module.exports = __webpack_public_path__ + "img/upload_image.5eb00766.png";